import { render, staticRenderFns } from "./data-upload.vue?vue&type=template&id=7ffcb235&scoped=true&"
import script from "./data-upload.vue?vue&type=script&lang=ts&"
export * from "./data-upload.vue?vue&type=script&lang=ts&"
import style0 from "./data-upload.vue?vue&type=style&index=0&id=7ffcb235&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffcb235",
  null
  
)

export default component.exports